import { createContext, useContext, ReactNode } from 'react';
import { useAccessibility } from '../hooks/use-accessibility';

type AccessibilityContextType = ReturnType<typeof useAccessibility>;

const AccessibilityContext = createContext<AccessibilityContextType | undefined>(undefined);

interface AccessibilityProviderProps {
    children: ReactNode;
}

export const AccessibilityProvider = ({ children }: AccessibilityProviderProps) => {
    const value = useAccessibility();

    return (
        <AccessibilityContext.Provider value={value}>
            {children}
        </AccessibilityContext.Provider>
    );
};

export const useAccessibilityContext = () => {
    const context = useContext(AccessibilityContext);
    if (context === undefined) {
        throw new Error('useAccessibilityContext must be used within an AccessibilityProvider');
    }
    return context;
};
